import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { openConsentPreferences, withdrawAllConsent } from '../utils/consentManager';

const Footer: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubscribing, setIsSubscribing] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email.trim()) {
      alert('Please enter a valid email address');
      return;
    }

    setIsSubscribing(true);

    try {
      // Send newsletter subscription directly to hello@mylvtrust.com
      const response = await fetch('https://formsubmit.co/ajax/hello@mylvtrust.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          email: email,
          subject: 'Newsletter Subscription',
          message: `New newsletter subscription from: ${email}`,
          type: 'newsletter'
        })
      });

      const result = await response.json();

      if (result.success) {
        setShowSuccess(true);
        setEmail('');
        setTimeout(() => setShowSuccess(false), 3000);
      } else {
        alert('Subscription failed. Please try again.');
      }
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      alert('Subscription failed. Please try again.');
    } finally {
      setIsSubscribing(false);
    }
  };
  return (
    <footer className="bg-primary text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.8fr_1fr_1.3fr_1.5fr_1.4fr] gap-6 mb-12">
          {/* Column 1: About */}
          <div>
            <div className="mb-6 flex items-center">
              <img
                src="/backend log/footerimg.png"
                alt="LV Trust Logo"
                className="h-16 w-auto object-contain"
              />
            </div>
            <div className="mb-6 pr-4">
              <p className="text-white/80 leading-relaxed">
                Through these initiatives, the Lakshmi Venkatesan Charitable Trust underscores the importance of mentorship in fostering entrepreneurship, creating sustainable businesses, and ultimately contributing to economic development in India.
              </p>
            </div>
            <div className="flex space-x-4">
              {/* LinkedIn */}
              <a href="https://www.linkedin.com/company/lvtrust" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white flex items-center justify-center hover:opacity-90 transition-opacity">
                <span className="sr-only">LinkedIn</span>
                <svg className="w-5 h-5 text-blue-700" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              {/* Facebook */}
              <a href="https://www.facebook.com/profile.php?id=61587095211533" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white flex items-center justify-center hover:opacity-90 transition-opacity">
                <span className="sr-only">Facebook</span>
                <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                </svg>
              </a>
              {/* Instagram */}
              <a href="https://www.instagram.com/mylvtrust" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white flex items-center justify-center hover:opacity-90 transition-opacity">
                <span className="sr-only">Instagram</span>
                <svg className="w-5 h-5 text-pink-600" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                </svg>
              </a>

              {/* YouTube */}
              {/* <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white flex items-center justify-center hover:opacity-90 transition-opacity">
                <span className="sr-only">YouTube</span>
                <svg className="w-5 h-5 text-red-600" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z" clipRule="evenodd" />
                </svg>
              </a> */}
            </div>
          </div>

          {/* Column 2: Quick Links - Narrower Column */}
          <div>
            <h4 className="text-xl font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3 text-white/80">
              <li>
                <Link to="/" className="hover:text-white hover:translate-x-1 inline-block transition-all">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-white hover:translate-x-1 inline-block transition-all">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/thematic-areas" className="hover:text-white hover:translate-x-1 inline-block transition-all">
                  Thematic Areas
                </Link>
              </li>
              <li>
                <Link to="/events" className="hover:text-white hover:translate-x-1 inline-block transition-all">
                  Events
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-white hover:translate-x-1 inline-block transition-all">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white hover:translate-x-1 inline-block transition-all">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Privacy Policy Notice (Centered between Quick Links and Contact Us) */}
          <div>
            <h4 className="text-xl font-bold mb-6">Privacy Policy Notice</h4>
            <ul className="space-y-3 text-white/80">
              <li>
                <Link to="/privacy-policy" className="hover:text-white hover:translate-x-1 inline-block transition-all">
                  Privacy Policy &amp; DPDPA Notice
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => openConsentPreferences()}
                  id="footer-manage-preferences"
                  className="hover:text-white hover:translate-x-1 inline-block transition-all text-left"
                >
                  Manage Privacy Preferences
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => withdrawAllConsent()}
                  id="footer-withdraw-consent"
                  className="text-red-300 hover:text-white hover:translate-x-1 inline-block transition-all text-left font-medium"
                  title="Withdraw all optional consents directly (§6(4) DPDPA)"
                >
                  Withdraw Consent
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => openConsentPreferences()}
                  className="hover:text-white hover:translate-x-1 inline-block transition-all text-left text-xs text-white/60"
                >
                  Interactive Notice
                </button>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Info */}
          <div>
            <h4 className="text-xl font-bold mb-6">Contact Us</h4>
            <ul className="space-y-4 text-white/80">
              <li className="flex items-start">
                <svg className="w-6 h-6 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                <span>58, 59 F-3 DJ Garden Extension, Ramamurthy Road, Selvapuram, Coimbatore-641026, TN <svg className="w-5 h-3 ml-1 inline" viewBox="0 0 24 16" fill="none">
                  <rect width="24" height="5.33" fill="#FF9933" />
                  <rect width="24" height="5.33" y="5.33" fill="white" />
                  <rect width="24" height="5.33" y="10.66" fill="#138808" />
                  <circle cx="12" cy="8" r="1.8" fill="#000080" />
                  <circle cx="12" cy="8" r="2.2" fill="none" stroke="#000080" strokeWidth="0.3" />
                  <path d="M12 6.5 L12.4 7.3 L13.2 7.3 L12.6 7.8 L12.8 8.6 L12 8.1 L11.2 8.6 L11.4 7.8 L10.8 7.3 L11.6 7.3 Z" fill="#000080" />
                </svg></span>
              </li>
              <li className="flex items-center">
                <svg className="w-6 h-6 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                <span>+91 9942019000</span>
              </li>
              <li className="flex items-center">
                <svg className="w-6 h-6 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                <span>hello@mylvtrust.com</span>
              </li>
            </ul>
          </div>

          {/* Column 5: Newsletter */}
          <div>
            <h4 className="text-xl font-bold mb-6">Stay Connected</h4>
            <p className="text-white/80 mb-4">Subscribe to our newsletter to get the latest updates.</p>

            {/* Success Message */}
            {showSuccess && (
              <div className="bg-green-500 text-white p-3 rounded-lg mb-4 text-center">
                <p className="font-semibold">Successfully subscribed!</p>
                <p className="text-sm">Thank you for subscribing to our newsletter.</p>
              </div>
            )}

            <form onSubmit={handleSubscribe} className="space-y-3">
              <div className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your Email Address"
                  className="flex-1 px-4 py-3 rounded bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:border-secondary"
                  required
                />
                <button
                  type="submit"
                  disabled={isSubscribing}
                  className="bg-secondary hover:bg-secondary-light text-white font-bold py-3 px-6 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubscribing ? 'Subscribing...' : 'Subscribe'}
                </button>
              </div>
              <p className="text-white/60 text-xs mt-2 leading-relaxed">
                We respect your data rights under DPDPA 2023. By subscribing, you agree to our{' '}
                <Link to="/privacy-policy" className="text-white underline hover:text-secondary-300">
                  Privacy Policy &amp; Notice
                </Link>.
              </p>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-white/60 text-sm space-y-2">
          <p>&copy; {new Date().getFullYear()} Lakshmi Venkatesan Charitable Trust. All Rights Reserved.</p>
          <div className="flex flex-wrap items-center justify-center gap-3 text-xs">
            <Link
              to="/privacy-policy"
              className="text-white/80 hover:text-white underline transition-colors"
            >
              Privacy Policy
            </Link>
            <span className="text-white/30">•</span>
            <button
              type="button"
              onClick={() => openConsentPreferences()}
              id="footer-bottom-manage-preferences"
              className="text-white/80 hover:text-white underline transition-colors"
            >
              Manage Privacy Preferences
            </button>
            <span className="text-white/30">•</span>
            <button
              type="button"
              onClick={() => withdrawAllConsent()}
              id="footer-bottom-withdraw-consent"
              className="text-red-300 hover:text-white underline transition-colors font-medium"
              title="Withdraw consent directly (§6(4))"
            >
              Withdraw Consent
            </button>
          </div>
          <p className="text-xs pt-1">Developed by <a href="https://bcbuzz.io"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-secondary-300 transition-colors">
            BCBUZZ Technologies Private Limited
          </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;